/**
 * PostHog kill-switch dla masowej generacji zdjęć potraw w szablonie diety (TRE-1830).
 *
 * Feature kosztuje realne pieniądze za kliknięcie (~$0.034 za zdjęcie), więc chcemy móc go zgasić
 * bez deployu — i wypuszczać stopniowo, zaczynając od wąskiej grupy trenerek.
 */
export const MEALS_PLAN_DISH_IMAGES_FEATURE_FLAG = "meals_plan_dish_images";
